/** Anonymous / guest homeowner id from REACT_APP_GUEST_USER_ID_IDS (.env). */
export const GUEST_USER_ID_IDS =
  process.env.REACT_APP_GUEST_USER_ID_IDS || "";

/**
 * Use stored user id when a session exists; otherwise the guest id from .env.
 */
export function getEffectiveUserId() {
  const token = localStorage.getItem("access_token");
  const uid = localStorage.getItem("user_id");
  if (token && uid) return uid;
  return GUEST_USER_ID_IDS;
}
